/** 应用级聊天窗口状态；消息事实仍由各领域协议管理，换号清理本地UI。 */
export default {
  namespaced: true,
  state: () => ({ open: false, docked: false, pinned: false, request: null, requestVersion: 0, handledMobileRequestVersion: 0, inboxPinsByUser: {} }),
  mutations: {
    /** 手机页面按版本消费打开意图，避免重进列表时再次请求旧会话。 */
    acknowledgeMobileRequest(state, version) { if (version === state.requestVersion) state.handledMobileRequestVersion = version; },
    open(state, request) { state.request = request; state.requestVersion++; state.open = true; state.docked = false; },
    show(state) { state.open = true; },
    dock(state, value) { state.docked = state.open && Boolean(value); },
    pin(state, value) { state.pinned = Boolean(value); },
    setInboxPins(state, { userId, pins }) { state.inboxPinsByUser = { ...state.inboxPinsByUser, [userId]: [...pins] }; },
    close(state) { state.open = false; state.docked = false; },
    reset(state) { state.open = false; state.docked = false; state.pinned = false; state.request = null; state.requestVersion++; state.inboxPinsByUser = {}; },
  },
};
